"use client";

import { QueryClient } from "@tanstack/react-query";
import { PersistQueryClientProvider } from "@tanstack/react-query-persist-client";
import { useState } from "react";

export function QueryProvider({ children }: { children: React.ReactNode }) {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 5 * 60 * 1000, // 5 minutes
            gcTime: 10 * 60 * 1000, // 10 minutes
            retry: 1,
          },
        },
      })
  );

  // Создаем простой localStorage persister
  const persister = {
    persistClient: (clientData: unknown) => {
      if (typeof window !== "undefined") {
        try {
          localStorage.setItem("aseed-query-cache", JSON.stringify(clientData));
        } catch {
          // Ignore storage errors
        }
      }
    },
    restoreClient: () => {
      if (typeof window !== "undefined") {
        try {
          const data = localStorage.getItem("aseed-query-cache");
          return data ? JSON.parse(data) : undefined;
        } catch {
          return undefined;
        }
      }
    },
    removeClient: () => {
      if (typeof window !== "undefined") {
        localStorage.removeItem("aseed-query-cache");
      }
    },
  };

  return (
    <PersistQueryClientProvider
      client={queryClient}
      persistOptions={{
        persister,
        maxAge: 24 * 60 * 60 * 1000, // 24 hours
      }}
    >
      {children}
    </PersistQueryClientProvider>
  );
}
